import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { ExtendedDosage } from '~libs.shared.prescription';

import { DraftPrescriptionsFormController } from '../../draftPrescriptions/DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../../draftPrescriptions/standardPrescription/DraftStandardPrescriptionField.types';

import { ExtendedDosageModal } from './ExtendedDosageModal';

type ExtendedDosageModalOpenerProps = Pick<DraftPrescriptionsFormController, 'setValue'> & {
   readonly children: (renderProps: { openModal: VoidFunction }) => JSX.Element;
   readonly name: DraftStandardPrescriptionFieldName;
   readonly dosageFieldName: DraftStandardPrescriptionFieldName;
   readonly dosage: string | null;
   readonly extendedDosage: ExtendedDosage | null;
   readonly medicine: MedicineSimple;
   readonly reimbursements: PatientMedicine['reimbursements'];
   readonly dosageFrequencyValidated: boolean;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const ExtendedDosageModalOpener = (props: ExtendedDosageModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ExtendedDosageModal
               setValue={props.setValue}
               name={props.name}
               dosageFieldName={props.dosageFieldName}
               dosage={props.dosage}
               extendedDosage={props.extendedDosage}
               medicine={props.medicine}
               reimbursements={props.reimbursements}
               dosageFrequencyValidated={props.dosageFrequencyValidated}
               visitDiagnoses={props.visitDiagnoses}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
